import _ from "lodash";
import {ControlDelivery} from "../../types/delivery/control-delivery";
import {DeliveryGroupType} from "../../types/schedule/delivery-group-type";

export const getIsDuplicated = (
    controlDeliveries: ControlDelivery[],
    newControlDelivery: ControlDelivery
) => {
    return controlDeliveries.some(
        (controlDelivery) => controlDelivery.key === newControlDelivery.key
    );
};

export const getIsSamePickUpTimeLimited = (
    controlDelivery: ControlDelivery,
    newControlDelivery: ControlDelivery
) => {
    if (controlDelivery.type === DeliveryGroupType.PickUp) {
        return (
            controlDelivery.delivery.pickUpAction.startTimeLimited ===
            newControlDelivery.delivery.pickUpAction.startTimeLimited
        );
    }
    return (
        controlDelivery.delivery.dropOffAction.startTimeLimited ===
        newControlDelivery.delivery.pickUpAction.startTimeLimited
    );
};

export const getIsSamePickUpLocation = (
    controlDelivery: ControlDelivery,
    newControlDelivery: ControlDelivery
) => {
    if (controlDelivery.type === DeliveryGroupType.PickUp) {
        return (
            controlDelivery.delivery.pickUpLocation.id ===
            newControlDelivery.delivery.pickUpLocation.id
        );
    }
    return (
        controlDelivery.delivery.dropOffLocation.id ===
        newControlDelivery.delivery.pickUpLocation.id
    );
};

export const findLastIndexBySamePickUpTimeLimitedAndLocation = (
    controlDeliveriesTemp: ControlDelivery[],
    newControlDelivery: ControlDelivery
) => {
    return _.findLastIndex(
        controlDeliveriesTemp,
        (controlDelivery) =>
            getIsSamePickUpTimeLimited(controlDelivery, newControlDelivery) &&
            getIsSamePickUpLocation(controlDelivery, newControlDelivery)
    );
};

export const findLastIndexBySamePickUpTimeLimited = (
    controlDeliveriesTemp: ControlDelivery[],
    newControlDelivery: ControlDelivery
) => {
    return _.findLastIndex(controlDeliveriesTemp, (controlDelivery) =>
        getIsSamePickUpTimeLimited(controlDelivery, newControlDelivery)
    );
};

export const getIsBiggerPickUpTimeLimited = (
    controlDelivery: ControlDelivery,
    newControlDelivery: ControlDelivery
) => {
    if (controlDelivery.type === DeliveryGroupType.PickUp) {
        return (
            controlDelivery.delivery.pickUpAction.startTimeLimited >
            newControlDelivery.delivery.pickUpAction.startTimeLimited
        );
    }
    return (
        controlDelivery.delivery.dropOffAction.startTimeLimited >
        newControlDelivery.delivery.pickUpAction.startTimeLimited
    );
};

export const findIndexByBiggerPickUpTimeLimited = (
    controlDeliveriesTemp: ControlDelivery[],
    newControlDelivery: ControlDelivery
) => {
    return _.findIndex(controlDeliveriesTemp, (controlDelivery) =>
        getIsBiggerPickUpTimeLimited(controlDelivery, newControlDelivery)
    );
};

export const getIsSameDropOffTimeLimited = (
    controlDelivery: ControlDelivery,
    newControlDelivery: ControlDelivery
) => {
    if (controlDelivery.type === DeliveryGroupType.PickUp) {
        return (
            controlDelivery.delivery.pickUpAction.startTimeLimited ===
            newControlDelivery.delivery.dropOffAction.startTimeLimited
        );
    }
    return (
        controlDelivery.delivery.dropOffAction.startTimeLimited ===
        newControlDelivery.delivery.dropOffAction.startTimeLimited
    );
};

export const getIsSameDropOffLocation = (
    controlDelivery: ControlDelivery,
    newControlDelivery: ControlDelivery
) => {
    if (controlDelivery.type === DeliveryGroupType.PickUp) {
        return (
            controlDelivery.delivery.pickUpLocation.id ===
            newControlDelivery.delivery.dropOffLocation.id
        );
    }
    return (
        controlDelivery.delivery.dropOffLocation.id ===
        newControlDelivery.delivery.dropOffLocation.id
    );
};

export const findLastIndexBySameDropOffTimeLimitedAndLocation = (
    controlDeliveriesTemp: ControlDelivery[],
    newControlDelivery: ControlDelivery
) => {
    return _.findLastIndex(
        controlDeliveriesTemp,
        (controlDelivery) =>
            getIsSameDropOffTimeLimited(controlDelivery, newControlDelivery) &&
            getIsSameDropOffLocation(controlDelivery, newControlDelivery)
    );
};

export const findLastIndexBySameDropOffTimeLimited = (
    controlDeliveriesTemp: ControlDelivery[],
    newControlDelivery: ControlDelivery
) => {
    return _.findLastIndex(controlDeliveriesTemp, (controlDelivery) =>
        getIsSameDropOffTimeLimited(controlDelivery, newControlDelivery)
    );
};

export const getIsBiggerDropOffTimeLimited = (
    controlDelivery: ControlDelivery,
    newControlDelivery: ControlDelivery
) => {
    if (controlDelivery.type === DeliveryGroupType.PickUp) {
        return (
            controlDelivery.delivery.pickUpAction.startTimeLimited >
            newControlDelivery.delivery.dropOffAction.startTimeLimited
        );
    }
    return (
        controlDelivery.delivery.dropOffAction.startTimeLimited >
        newControlDelivery.delivery.dropOffAction.startTimeLimited
    );
};

export const findIndexByBiggerDropOffTimeLimited = (
    controlDeliveriesTemp: ControlDelivery[],
    newControlDelivery: ControlDelivery
) => {
    return _.findIndex(controlDeliveriesTemp, (controlDelivery) =>
        getIsBiggerDropOffTimeLimited(controlDelivery, newControlDelivery)
    );
};

export const getPickUpControlDelivery = (
    newControlDelivery: ControlDelivery
) => {
    return {
        ...newControlDelivery,
        key: newControlDelivery.delivery.id + DeliveryGroupType.PickUp,
        type: DeliveryGroupType.PickUp,
    };
};

export const getDropOffControlDelivery = (
    newControlDelivery: ControlDelivery
) => {
    return {
        ...newControlDelivery,
        key: newControlDelivery.delivery.id + DeliveryGroupType.DropOff,
        type: DeliveryGroupType.DropOff,
    };
};

export const getSplitControlDelivery = (
    newControlDelivery: ControlDelivery
) => {
    return {
        ...newControlDelivery,
        key: newControlDelivery.delivery.id + DeliveryGroupType.Split,
        type: DeliveryGroupType.Split,
    };
};

export const insertControlDelivery = (
    controlDeliveries: ControlDelivery[],
    index: number,
    newControlDelivery: ControlDelivery
) => {
    controlDeliveries.splice(index, 0, newControlDelivery);
};
